import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'NoticeDeliveryStatusModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: false,
      // テーブルオプション
      tableColumns: [
        'deviceSerial',
        'locationNumber',
        'profile1Body',
        'readAt',
      ],
      tableData: [],
      tableOptions: {
        headings: {
          deviceSerial: '端末製造番号',
          locationNumber: 'ロケーションID',
          readAt: '閲覧日時',
          profile1Body: 'プロフィール１'
        },
        columnsClasses: {
          deviceSerial: '',
          locationNumber: '',
          readAt: '',
          profile1Body: ''
        },
        sortable: [
          'deviceSerial',
          'locationNumber',
          'readAt',
          'profile1Body'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('閲覧状況'),
        perPage: Constants.TableOptions.perPage.modal,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      noticeId: state => state.noticeDetail.targetId,
      noticeReadInfoModel: state => state.noticeDeliveryStatusModal.noticeReadInfoModel,
      active: state => state.noticeDeliveryStatusModal.active,
      noticeDetailInfoModel: state => state.noticeDetail.infoModel,
      noticeModel: state => state.notice.noticeModel,
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },
    disableDownloadCsvButton() {
      return this.tableData.length > 0;
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      loadModel: 'noticeDeliveryStatusModal/loadModel',
      hide: 'noticeDeliveryStatusModal/hide'
    }),

    init () {
      this.loading = true

      // パラメータ
      let noticeReadInfoParams = {
        noticeDeliveryUuid: this.noticeId
      }

      // データ読出し
      this.loadModel({
        noticeReadInfoParams: noticeReadInfoParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.noticeReadInfoModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'readAt':
        case 'thumbupAt':
          return Utility.dateFormat(value, 'YYYY/MM/DD HH:mm')
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    },
    downloadNoticeDelivery() {
      this.loading = true;
      let name = "";
      const noticeData = this.noticeModel.filter(
        item => item.noticeDeliveryUuid === this.noticeId
      );
      const date = new Date();
      const fullYear = date.getFullYear();
      let month = date.getMonth() + 1;
      if (month < 10) month = "0" + month;
      let day = date.getDate();
      if (day < 10) day = "0" + day;
      let hour = date.getHours();
      if (hour < 10) hour = "0" + hour;
      name =
        this.noticeDetailInfoModel["serviceName"] +
        "_" +
        (noticeData.length > 0 ? noticeData[0]["noticeDeliveryId"] : "") +
        "_閲覧状況ログ" +
        "_" +
        fullYear.toString() +
        month +
        day +
        hour;
      let data = [
        ["ロケーションID", "端末製造番号", "プロフィール１", "閲覧日時"]
      ];
      this.noticeReadInfoModel.map((item, index) => {
        data.push([
          item.locationNumber,
          item.deviceSerial,
          item.profile1Body,
          (item.readAt ? Utility.dateFormat(item.readAt, "YYYY/MM/DD HH:mm") : "")
        ]);
      });
      const csvContent = data.map(row => row.join(",")).join("\n");

      const blob = new Blob([String.fromCharCode(0xfeff), csvContent], {
        type: "data:text/csv;charset=utf-8;"
      });
      const url = URL.createObjectURL(blob);
      const element = document.createElement("a");
      element.href = url;
      element.setAttribute("download", name + ".csv");
      element.style.visibility = "hidden";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
      this.loading = false;
    }
  }
}